import * as THREE from 'three';

export default class Camera {
  constructor(experience) {
    this.experience = experience;
    this.sizes = this.experience.sizes;
    this.scene = this.experience.scene;
    this.canvas = this.experience.canvas;

    this.setInstance();
  }

  setInstance() {
    this.container = new THREE.Group();
    this.scene.add(this.container);

    this.instance = new THREE.PerspectiveCamera(
      32,
      this.sizes.width / this.sizes.height,
      0.1,
      100
    );
    // Responsive camera distance: pulls back smoothly on tall/narrow mobile screens
    this.instance.position.set(0, 0, this.getBaseZ());
    this.container.add(this.instance);
  }

  getBaseZ() {
    const aspect = this.sizes.width / this.sizes.height;
    // Responsive camera distance: pulls back smoothly to give generous breathing room
    if (aspect < 1) {
      return 21.0 + (1 - aspect) * 11.0; // Between 24.0 and 26.5 on mobile devices
    }
    return 20.0; // Increased from 16.0 to 20.0 on desktop for more atmospheric depth
  }

  resize() {
    this.instance.aspect = this.sizes.width / this.sizes.height;
    this.instance.position.z = this.getBaseZ();
    this.instance.updateProjectionMatrix();
  }

  update() {
    if (!this.experience.mouse) return;

    // Subtle, elegant camera parallax
    const targetX = this.experience.mouse.current.x * 0.9;
    const targetY = this.experience.mouse.current.y * 0.55;

    this.container.position.x += (targetX - this.container.position.x) * 0.05;
    this.container.position.y += (targetY - this.container.position.y) * 0.05;

    this.instance.rotation.y = -this.container.position.x * 0.07;
    this.instance.rotation.x = this.container.position.y * 0.07;
  }
}
